<div
  (click)="onClick()"
  class="card flex-c"
  [ngStyle]="{
    '--bg-color': card.color80,
    '--text-color': card.color0,
    '--hover-color': card.color70,
  }">
  @if (card.url) {
    <div
      class="image"
      [style]="{ 'background-image': 'url(' + card.url + ')' }"></div>

    <div class="card-title">{{ card.title }}</div>
  } @else {
    <div class="center-card-title">{{ card.title }}</div>
  }
</div>
